import $ from 'jquery';
import PerfectScrollbar from 'perfect-scrollbar';

let index = 0;
const scrollbars = {};

$(document).on('init', '.ui-scroll', function () {
    if ($(this).attr('data-index')) {
        return;
    }

    index++;
    let _index = index;
    $(this).attr('data-index', _index);
    scrollbars[_index] = new PerfectScrollbar($(this)[0], {
        wheelSpeed: 1,
        wheelPropagation: true,
        minScrollbarLength: 100,
        suppressScrollY: $(this).hasClass('ui-scroll--x')
    });
}).on('update', '.ui-scroll', function () {
    scrollbars[$(this).attr('data-index')].update();
});

$('.ui-scroll').each(function () {
    $(this).trigger('init');
});
